import { render, staticRenderFns } from "./SalesPreferences.vue?vue&type=template&id=cd37c616&scoped=true"
import script from "./SalesPreferences.vue?vue&type=script&lang=ts"
export * from "./SalesPreferences.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd37c616",
  null
  
)

export default component.exports